// Global Instructions Rule Applied!
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store.ts'
import { MENU_ITEM_KEY_INVESTOR_STATEMENTS, REPORT_CONFIG_NAME_INVESTOR_STATEMENT_RUNS } from '../globals.ts'
import { resolveReportIdForMenuItem } from '../utils/reportingGridColumns.ts'

/** `reporting_config.id` for the Investor Statements runs grid column layout (from global configs). */
export function useInvestorStatementRunsReportId(): string | undefined {
  const menuItems = useSelector((state: RootState) => state.globalConfigs?.menu_items ?? [])
  const reportingConfigs = useSelector((state: RootState) => state.globalConfigs?.reporting_configs ?? [])

  return useMemo(
    () =>
      resolveReportIdForMenuItem(
        reportingConfigs,
        menuItems,
        MENU_ITEM_KEY_INVESTOR_STATEMENTS,
        REPORT_CONFIG_NAME_INVESTOR_STATEMENT_RUNS
      ),
    [menuItems, reportingConfigs]
  )
}
